import { FC, useEffect, useRef, useState } from 'react';

import { corsina, corsinaW, errorIcon, imgs, prizeGray, refr } from '../../assets';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { WalletClient } from '../../generated/mlmbox/client/finance/wallet.client';
import { getToken } from '../../utils/helper';
import { GiftShop_Info } from '../../generated/mlmbox/types/gift_shop';

import { useNavigate, useParams } from 'react-router';
import { createCard, updateCard } from '../../shared/api/market';
import Loader from '../../components/Loader/Loader';
import { Wallet_Processing_Asset } from '../../generated/mlmbox/types/wallet';
import MessageStick from '../../shared/ui/MessageStick/MessageStick';
import { transport } from '../../utils/constants';
import { getCard, removeCard } from '../../shared/api/market/card';
import styles from './CreateCard.module.scss';
import PageHeader from '../../shared/ui/PageHeader/PageHeader';
import { set } from 'date-fns';
import Button from '../../shared/ui/Button/Button';

const CreateCard: FC = () => {
    const min = 100;
    const { cardId } = useParams();
    const [cardInfo, setCardInfo] = useState<GiftShop_Info>();
    const walletClient = new WalletClient(transport);
    const { t } = useTranslation();
    const [img, setImg] = useState<string>('');
    const [picture, setPicture] = useState<string>();
    const [loading, setLoading] = useState(cardId ? true : false);
    const [saving, setSaving] = useState<boolean>(false);

    const [fields, setFields] = useState<{ description: string; title: string; image: Uint8Array<ArrayBuffer>; priceValue: string }>({
        description: '',
        title: '',
        image: new Uint8Array(),
        priceValue: '',
    });
    const [fieldsCopy, setFieldsCopy] = useState<{ description: string; title: string; image: Uint8Array<ArrayBuffer>; priceValue: string }>({
        description: '',
        title: '',
        image: new Uint8Array(),
        priceValue: '',
    });
    const [fee, setFee] = useState<Wallet_Processing_Asset>();
    const [points, setPoints] = useState(0);
    const [error, setError] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading || !cardId) return;

        getCard(Number(cardId)).then((res) => {
            if (res?.card) {
                setFields({
                    description: res.card.description,
                    title: res.card.title,
                    image: new Uint8Array(),
                    priceValue: String(Number(res.card.usdtPrice)),
                });
                setFieldsCopy({
                    description: res.card.description,
                    title: res.card.title,
                    image: new Uint8Array(),
                    priceValue: String(Number(res.card.usdtPrice)),
                });
                setImg(`${import.meta.env.VITE_API_URL}/${res.card.imageSrc}`);
                setCardInfo(res);

                setLoading(false);
                return;
            }
            navigate(`/card/${cardId}`);
        });
    }, []);

    useEffect(() => {
        walletClient.processingsGet({ processingId: 1 }, { meta: { authorization: getToken() } }).then(({ response }) => {
            setFee(response.assets[0]);
        });
    }, []);

    function handleClick() {
        if (Number(fields.priceValue) < min) {
            setError(true);
            return;
        }

        setSaving(true);

        if (!cardInfo)
            createCard(fields).then((data) => {
                if (data?.card) navigate(`/card/${data.card.id}`);

                if (!data) {
                    // message.error('Не удалось создать');
                }

                setSaving(false);
            });

        if (cardInfo && cardInfo.card)
            updateCard({
                ...fields,
                cardId: cardInfo.card.id,
            }).then((data) => {
                if (data?.card) navigate(`/card/${data.card.id}`);

                if (!data) {
                    // message.error('Ошибка редактирования');
                }
                setSaving(false);
            });
    }

    function handleRemove() {
        if (!cardInfo?.card) return;
        setSaving(true);

        removeCard(cardInfo.card.id).then((data) => {
            if (data) return navigate(`/market`);

            message.error('Не удалось удалить');
            setSaving(false);
        });
    }

    function addFile() {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }

    function validData() {
        if (
            !cardInfo &&
            fields.title &&
            fields.priceValue &&
            fields.image &&
            fields.image.length &&
            fields.description &&
            800 - fields.description.length >= 0
        )
            return true;

        if (cardInfo && JSON.stringify({ ...fields }) !== JSON.stringify({ ...fieldsCopy })) return true;
        return false;
    }

    async function imgSubmit(img: File) {
        try {
            const buffer = await img.arrayBuffer();

            setFields((prev) => ({ ...prev, image: new Uint8Array(buffer) }));
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        // setError(false);
        if (!fields.priceValue && !fee) return setPoints(0);
        const fe = Number(fields.priceValue) * Number(fee?.settingsWithdrawalFeePercent) + Number(fee?.settingsWithdrawalFeeBase);

        if (Number(fields.priceValue) > 0) {
            setPoints(Math.ceil((Number(fields.priceValue) + fe) / 10));
        } else {
            setPoints(0);
        }
    }, [fields.priceValue, fee]);

    useEffect(() => {
        if (loading) return;
        window.Telegram.WebApp.MainButton.color = '#007AFF';
        window.Telegram.WebApp.MainButton.textColor = '#fff';
        window.Telegram.WebApp?.MainButton.setText(cardInfo ? t('btns.save') : t('add'));
        window.Telegram.WebApp?.MainButton.show();

        return () => {
            window.Telegram.WebApp?.MainButton.hideProgress();
            window.Telegram.WebApp?.MainButton.hide();
        };
    }, [loading]);

    useEffect(() => {
        if (loading) return;

        if (validData() && !saving) {
            window.Telegram.WebApp?.MainButton.enable();
            window.Telegram.WebApp.MainButton.color = '#007AFF';
            window.Telegram.WebApp.MainButton.textColor = '#fff';
        } else {
            window.Telegram.WebApp?.MainButton.disable();
            window.Telegram.WebApp.MainButton.color = '#333';
            window.Telegram.WebApp.MainButton.textColor = '#777';
        }

        if (saving) {
            window.Telegram.WebApp?.MainButton.showProgress();
        } else {
            window.Telegram.WebApp?.MainButton.hideProgress();
        }
    }, [saving, fields, loading]);

    useEffect(() => {
        window.Telegram.WebApp?.MainButton.onClick(handleClick);

        return () => {
            window.Telegram.WebApp?.MainButton.offClick(handleClick);
        };
    }, [fields]);

    return (
        <>
            {!loading && (
                <div className={styles.createCard}>
                    <div className="start">
                        <PageHeader
                            title={t('add_btn')}
                            closeBtn={() => (cardId ? navigate(`/card/${cardId}`) : navigate('/market'))}
                        />
                        <div className={styles.img}>
                            <div
                                className={styles.content}
                                style={{ display: !picture ? 'none' : 'flex' }}>
                                <div
                                    className={styles.delete}
                                    onClick={() => {
                                        if (!cardInfo) {
                                            setImg('');
                                            setPicture('');
                                            setFields((prev) => ({ ...prev, image: new Uint8Array() }));
                                        } else {
                                            inputRef.current && inputRef.current.click();
                                        }
                                    }}>
                                    {cardInfo ? (
                                        <img
                                            style={{ width: '18px', height: '18px' }}
                                            className={styles.corsina}
                                            src={refr}
                                            alt=""
                                        />
                                    ) : (
                                        <img
                                            className={styles.corsina}
                                            src={corsina}
                                            alt=""
                                        />
                                    )}
                                </div>
                                <span style={{ backgroundImage: `url(${img})` }}></span>
                                <img
                                    onLoad={() => {
                                        img && setPicture(img);
                                    }}
                                    src={img}
                                    alt=""
                                />
                            </div>
                            {!picture && img && (
                                <div className="load-market">
                                    <Loader />
                                </div>
                            )}
                            {
                                <input
                                    ref={inputRef}
                                    style={{ width: 0, height: 0, opacity: 0 }}
                                    type="file"
                                    onChange={(e) => {
                                        e.target.files?.length && setImg(URL.createObjectURL(e.target.files[0]));
                                        e.target.files?.length && imgSubmit(e.target.files[0]);
                                    }}
                                />
                            }

                            {!img && (
                                <div className={styles.addFile}>
                                    <img
                                        className={styles.imgs}
                                        src={imgs}
                                        alt=""
                                    />

                                    <div className={styles.text}>
                                        <h2>{t('addFileTitle')}</h2>
                                        <p>{t('format')}</p>
                                    </div>
                                    <div
                                        onClick={addFile}
                                        className={styles.button}>
                                        {t('sel')}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className={styles.fields}>
                            <div className={styles.title}>
                                <label htmlFor="title">{t('name')}</label>
                                <input
                                    placeholder={t('nameD')}
                                    type="text"
                                    id="title"
                                    value={fields.title}
                                    onChange={(e) => setFields((prev) => ({ ...prev, title: e.target.value }))}
                                />
                            </div>
                            <div className={styles.price}>
                                <label htmlFor="price">{t('price')}</label>
                                <div className={styles.in}>
                                    <input
                                        placeholder={'0'}
                                        type="number"
                                        id="price"
                                        value={Number(fields.priceValue) <= 0 ? '' : Number(fields.priceValue)}
                                        // value={fields.priceValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                                        onChange={(e) => {
                                            setError(false);
                                            setFields((prev) => ({ ...prev, priceValue: e.target.value }));
                                        }}
                                    />
                                    <span>$</span>
                                    <div className={styles.bl}>
                                        <p>{points.toLocaleString()}</p>
                                        <img
                                            src={prizeGray}
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                            {error && (
                                <MessageStick
                                    style={{ marginTop: '18px' }}
                                    animation
                                    icon={errorIcon}
                                    title={`Минимальная стоимость желания ${min}$`}
                                    bg="rgba(255, 78, 99, 0.05)"
                                />
                            )}
                            <div className={styles.line}></div>
                            <div className={styles.desc}>
                                <label htmlFor="desc">{t('de')}</label>
                                <div className={styles.tA}>
                                    <textarea
                                        placeholder={t('ded')}
                                        id="desc"
                                        value={fields.description}
                                        onChange={(e) => setFields((prev) => ({ ...prev, description: e.target.value }))}
                                    />
                                    <div className={styles.c}>
                                        {fields.description.length > 0 ? (
                                            <img
                                                onClick={() => setFields((prev) => ({ ...prev, description: '' }))}
                                                src={corsina}
                                                alt=""
                                                className="cor"
                                            />
                                        ) : (
                                            <></>
                                        )}

                                        <p style={{ color: 800 - fields.description.length < 0 ? 'rgba(255, 78, 99, 1)' : 'rgba(76, 84, 99, 1) ' }}>
                                            {800 - fields.description.length}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {cardInfo && (
                            <div style={{ margin: '20px 16px 0px 16px' }}>
                                <Button
                                    style={{ backgroundColor: '#FF4E630D' }}
                                    title={'Удалить желание'}
                                    icon={corsinaW}
                                    onClick={handleRemove}
                                />
                            </div>
                        )}
                        {/*<Button*/}
                        {/*    onClick={handleClick}*/}
                        {/*    title={'save'}*/}
                        {/*>*/}

                        {/*</Button>*/}
                    </div>
                </div>
            )}
        </>
    );
};

export default CreateCard;
